import React, { useEffect, useState } from 'react';

const MOUSE_MOVE = 'CORNERSTONE_TOOLS_MOUSE_MOVE';

export interface CursorCoordinatesItemProps {
  element?: HTMLElement;
  instance?: { Modality?: string };
  customization?: { color?: string };
}

export default function CursorCoordinatesItem({
  element,
  instance,
  customization,
}: CursorCoordinatesItemProps) {
  const [coordinates, setCoordinates] = useState<{ x: number; y: number } | null>(null);

  useEffect(() => {
    if (!element) {
      return undefined;
    }

    const update = (event: Event) => {
      const currentPoints = (event as CustomEvent).detail?.currentPoints;

      if (!currentPoints?.canvas) {
        return;
      }

      setCoordinates({
        x: Math.round(currentPoints.canvas[0]),
        y: Math.round(currentPoints.canvas[1]),
      });
    };

    element.addEventListener(MOUSE_MOVE, update);

    return () => {
      element.removeEventListener(MOUSE_MOVE, update);
    };
  }, [element]);

  if (!coordinates || instance?.Modality !== 'CT') {
    return null;
  }

  return (
    <div
      className="overlay-item flex flex-row"
      style={{ color: customization?.color }}
    >
      <span className="mr-1 shrink-0">X:</span>
      <span className="ml-1 mr-2 shrink-0">{coordinates.x}</span>
      <span className="mr-1 shrink-0">Y:</span>
      <span className="ml-1 shrink-0">{coordinates.y}</span>
    </div>
  );
}
